// extracted by mini-css-extract-plugin
export default {"item":"styles_item__CPsCH","delete":"styles_delete__nE4TV"};